import { render, staticRenderFns } from "./Modelo3Component.vue?vue&type=template&id=67dc049e"
import script from "./Modelo3Component.vue?vue&type=script&lang=js"
export * from "./Modelo3Component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports